import React, { useContext } from 'react'
import { ExperimentContext } from '@cred/react-experiments/provider'

const withExperiments = WrappedComponent => props => {
  const experiments = useContext(ExperimentContext)
  return <WrappedComponent {...props} experiments={experiments} />
}


export default withExperiments
